const configApp = {
  academyDomain: 'https://vidroop.com/academia',
  academyUrl: 'vidroop',
  apiKeyTinyMce: 'nmmuxa1oi0rlug1hougubvrgge2hhd73ju9jq5thrlvy62gi',
  apiUrl: 'https://api.vidroop.com',
  apiVersion: 'v1',
  appAcademyDomain: 'https://academia.vidroop.com',
  appDomain: 'https://ventas.vidroop.com',
  authCallbackUrl: 'https://ventas.vidroop.com/login-callback',
  authClientId: '2yY2oyOfUr4GP0bAgropR0WsgW957kWE',
  authDomain: 'vidroop.eu.auth0.com',
  marketPlaceDomain: 'https://tienda.vidroop.com/academia',
  universityDomain: 'http://aula.vidroop.com/login/aaae93fb-3b33-417b-89d1-302f54fcff2b',
  vidroopAcademyUUID: 'aaae93fb-3b33-417b-89d1-302f54fcff2b'
}

export default configApp
